import { render, staticRenderFns } from "./SubscriptionMaritalStatus.vue?vue&type=template&id=283cb1c5&scoped=true"
import script from "./SubscriptionMaritalStatus.vue?vue&type=script&lang=ts"
export * from "./SubscriptionMaritalStatus.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionMaritalStatus.vue?vue&type=style&index=0&id=283cb1c5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283cb1c5",
  null
  
)

export default component.exports